import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo9/ministra.png";
import Imagen2 from "../../../images/modulo9/presidenta.png";
import Imagen3 from "../../../images/modulo9/vicepresidente.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 3.mp3";

const Actividad3 = () => {
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "ministra" },
    ans2: { value: "", valid: "", correctValue: "presidenta" },
    ans3: { value: "", valid: "", correctValue: "vicepresidente" },
  });
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[2];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo9.content[0].activities[3].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[3].path}`,
    titlePrev: `${modulo9.content[0].activities[1].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[1].path}`,
  };

  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };
  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul className="mb-5">
        <li>
          El Poder Ejecutivo está conformado por el presidente, los
          vicepresidentes y los ministros.
        </li>
        <li>Escribe el nombre del cargo de cada persona.</li>
      </ul>

      <div className="row">
        <div className="col-md-4 col-12">
          <div className="text-center">
            <img src={Imagen1} alt="Ministra" className="img-fluid w-120" />
            <div className="text-center mt-1">
              Soy una{" "}
              <input
                type="text"
                className={
                  "input-text-sm d-inline w-120 form-control me-2 " +
                  answers.ans1.valid
                }
                value={answers.ans1.value}
                onChange={(event) => handleAnswers(event, "ans1")}
              />
            </div>
          </div>
          <p className="m-3">
            Me encargo de dirigir los servicios públicos, por ejemplo, el
            trabajo y la salud.
          </p>
        </div>
        <div className="col-md-4 col-12">
          <div className="text-center">
            <img src={Imagen2} alt="Ministra" className="img-fluid w-120" />
            <div className="text-center mt-1">
              Soy la{" "}
              <input
                type="text"
                className={
                  "input-text-sm d-inline w-120 form-control me-2 " +
                  answers.ans2.valid
                }
                value={answers.ans2.value}
                onChange={(event) => handleAnswers(event, "ans2")}
              />
            </div>
          </div>
          <p className="m-3">
            Me encargo de dirigir el gobierno del país. Hago cumplir la
            Constitución y las leyes.
          </p>
        </div>
        <div className="col-md-4 col-12">
          <div className="text-center">
            <img src={Imagen3} alt="Ministra" className="img-fluid w-140" />
            <div className="text-center mt-1">
              Soy el{" "}
              <input
                type="text"
                className={
                  "input-text-sm d-inline w-120 form-control me-2 " +
                  answers.ans3.valid
                }
                value={answers.ans3.value}
                onChange={(event) => handleAnswers(event, "ans3")}
              />
            </div>
          </div>
          <p className="m-3">
            Reemplazo al presidente cuando este sale de viaje fuera del Perú.
          </p>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end mt-5">
        <button
          className={`btn btn-${modulo9.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <div className="row mt-5">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Ahora piensa en esto: ¿cuál es tu función como estudiante en la
              escuela? Convérsalo con un compañero, compañera o familiar y
              escríbelo en el recuadro.
            </li>
          </ul>
          <textarea className="form-control" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Observen las imágenes y lean las descripciones.
          Ayude a responder: la ministra se encarga de los servicios públicos,
          la presidenta de gobernar y el vicepresidente de reemplazarla.
          Destaque que la función es la actividad específica que realiza alguien
          en un contexto determinado. Luego, lea la última indicación y ayude a
          responder a partir del diálogo.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad3;
